import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainer,
  rendezVousChoiceTypeContainer,
  rendezVousCheckbox,
} from "./rendez-vous-part-1.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousInputType,
} from "../rendez-vous-styled.js"

export const RendezVousPart1 = ({
  sortedTypesRendezVousData,
  changeType,
  typeChoisi,
}) => {
  return (
    <RendezVousSubContainer className={rendezVousSubContainer}>
      <RendezVousTitle className={rendezVousTitle}>
        Choix du type de rendez-vous
      </RendezVousTitle>
      <div className={rendezVousChoiceTypeContainer}>
        {sortedTypesRendezVousData &&
          Object.keys(sortedTypesRendezVousData).map((key, index) => (
            <div key={index}>
              <label htmlFor={sortedTypesRendezVousData[key].id}>
                <RendezVousInputType
                  type="radio"
                  className={rendezVousCheckbox}
                  value={sortedTypesRendezVousData[key].id}
                  checked={
                    parseInt(sortedTypesRendezVousData[key].id) ===
                    parseInt(typeChoisi)
                  }
                  name="choixType"
                  id={sortedTypesRendezVousData[key].id}
                  onClick={() => changeType(sortedTypesRendezVousData[key].id)}
                />{" "}
                <span>{sortedTypesRendezVousData[key].libelle}</span>
              </label>
            </div>
          ))}
      </div>
    </RendezVousSubContainer>
  )
}

RendezVousPart1.propTypes = {
  sortedTypesRendezVousData: PropTypes.array,
  changeType: PropTypes.func,
  typeChoisi: PropTypes.string,
}
